/* eslint-disable import/prefer-default-export */
// @ts-check
import { computed } from 'vue'
import { useGetters } from 'vuex-composition-helpers/dist'

/**
 * Checks if a flag is enabled, loading is true until flags are set
 *
 * @param {string} flag to check
 * @returns {[import('vue').ComputedRef<boolean>, import('vue').ComputedRef<boolean>]} loading, enabled
 */
export function useFlagEnabled (flag) {
  /** @type {import('@/store/modules/featureFlags').Getters} */
  const { hasFlags, featureEnabled } = useGetters({
    hasFlags: 'featureFlags/hasFlags',
    featureEnabled: 'featureFlags/featureEnabled'
  })

  const loading = computed(() => !hasFlags.value)
  const enabled = computed(() => hasFlags.value && featureEnabled.value(flag))

  return [loading, enabled]
}
